import { CasaSettingsState } from './state';
import { CasaSettingsActionsUnion, CasaSettingsActionTypes } from './actions';

export const casaSettingsDefaultState: CasaSettingsState = {
  settings: undefined,
  loaded: false,
  loading: false,
  error: undefined
};

export function casaSettingsReducer(
  state = casaSettingsDefaultState,
  action: CasaSettingsActionsUnion
): CasaSettingsState {
  switch (action.type) {
    case CasaSettingsActionTypes.Load:
      return {
        ...state,
        loading: true,
        loaded: false
      };
    case CasaSettingsActionTypes.LoadSuccess:
      return {
        ...state,
        settings: action.payload,
        loaded: true,
        loading: false,
        error: undefined
      };
    case CasaSettingsActionTypes.LoadFail:
      return {
        ...state,
        settings: undefined,
        loaded: false,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}

export const getSettings = (state: CasaSettingsState) => state.settings;
